import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MobileBenefitsModal from './MobileBenefitsModal';
import './Auth.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      await register(email, password, name);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <MobileBenefitsModal />
      <div className="auth-content-wrapper">
        <div className="auth-benefits">
          <h2 className="auth-benefits-title">Your Literary Companion</h2>
          <p className="auth-benefits-subtitle">Start for free and unlock powerful reading resources</p>
          <ul className="auth-benefits-list">
            <li>
              <span className="benefit-icon">📚</span>
              <div>
                <h3>AI-Powered Summaries</h3>
                <p>Get comprehensive, detailed summaries of any book to enhance your understanding</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">💬</span>
              <div>
                <h3>Interactive Q&A</h3>
                <p>Ask questions about any book and receive intelligent, contextual answers</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">📖</span>
              <div>
                <h3>Study Guides & Discussion Outlines</h3>
                <p>Generate chapter-by-chapter study guides perfect for book clubs and academic study</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">⭐</span>
              <div>
                <h3>Personal Library</h3>
                <p>Save your favorite books and track your reading journey in one place</p>
              </div>
            </li>
          </ul>
        </div>
        <div className="auth-card">
          <h1>Create Account</h1>
          <p className="auth-subtitle">Join us to get started</p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Name (Optional)</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
              />
            </div>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
                autoFocus
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                minLength={6}
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating account...' : 'Sign Up'}
            </button>
          </form>
          <p className="auth-footer">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
